'use client';

import { ReactNode } from 'react';

import classNames from 'classnames';
import Image, { StaticImageData } from 'next/image';

import typography from '@/styles/typography.module.scss';

import styles from './styles.module.scss';

export default function PossibilityCard({
  cardData,
}: {
  cardData: { title: ReactNode; description: ReactNode; image: StaticImageData };
}) {
  return (
    <div className={styles.card}>
      <div className={styles.cardBody}>
        <div className={styles.cardIcon}>
          <Image src={cardData.image} alt={'offer icon'} width={80} height={80} />
        </div>
        <div className={styles.cardTitle}>
          <h4 className={classNames(typography.h4, styles.cardTitle)}>{cardData.title}</h4>
        </div>
        <div className={classNames(styles.cardDescription)}>
          <p className={typography.bodyM}>{cardData.description}</p>
        </div>
      </div>
    </div>
  );
}
